<template>
  <div class="vehicle-card">
    <vx-card v-if="vehicle" class="mt-4">
      <div class="flex vehicle-body-area" @click="onClick">
        <div class="mr-3 vehicle-img-area flex items-center">
          <vs-avatar class="m-0" :src="picture" size="48px" @mouseover="turnOverPicture" @mouseout="setOriginalPicture"  />
        </div>
        <div class="w-5/6 bg-grid-color-secondary h-12">
          <div class="flex w-full justify-between items-start vehicle-label">
            <span class="aisea-text-14-400-white">
              {{ vehicle.label }}
            </span>
          </div>
          <div class="flex vehicle-info-area mt-2">
            <div class="w-1/2">
              <span class="aisea-text-12-400-white">
                <!-- 種別 -->
                {{ $t("Views.Vessel.Kinds") }}: 車両
              </span>
            </div>
            <div class="w-1/2">
              <span class="aisea-text-12-400-white">
                <!-- 最終受信 --> 
                {{ $t("Views.Vessel.LastReceived") }}: {{ lastReceived || defaultValues.chara }}
              </span>
            </div>
          </div>
          <div class="flex vehicle-info-area mt-2">
            <div class="w-1/2">
              <span class="aisea-text-12-400-white">
                <!-- トラッキモid -->
                {{ $t("Views.Vessel.TrackimoId") }}: {{ vehicle.trackimo_id || defaultValues.chara }}
              </span>
            </div>
            <div class="w-1/2">
              <span class="aisea-text-12-400-white">
                <!-- バッテリ % -->
                {{ $t("Views.Vessel.Battery") }}: {{ vehicle.battery || defaultValues.chara }}%
              </span>
            </div>
          </div>
        </div>
      </div>
      <transition name="fade">
        <div class="clicked-card-opacity" v-if="shade"></div>
      </transition>
    </vx-card>
  </div>
</template>

<script>
import { DateUtil } from "@/utils";
import {createNamespacedHelpers} from "vuex";

// Mixins
import {ColorMixin, VehicleMixin} from "@/mixins";

const {
  mapMutations: mapMutationsOfLiveMap
} = createNamespacedHelpers("liveMap");

export default {
  mixins: [ColorMixin, VehicleMixin],
  props: {
    vehicle: { type: Object, default: null }
  },
  data() {
    return {
      picture: require("@/assets/images/no_image_bg.svg"),
      defaultValues: {
        num: "0",
        chara: "--",
        text: ""
      },
      shade: false,
      vehicleIcon:                 require("@/assets/images/vehicles/vehicle_menu_normal.svg"),
      vehicleIconInversion:        require("@/assets/images/vehicles/vehicle_menu_hover.svg" ),
      heavyEquipmentIcon:          require("@/assets/images/vehicles/heavy_menu_normal.svg"  ),
      heavyEquipmentIconInversion: require("@/assets/images/vehicles/heavy_menu_hover.svg"   ),
    };
  },
  computed: {
    lastReceived() {
      if (this.vehicle) {
        return this.vehicle.time !== undefined
          ? DateUtil.elapsedTimeByTimestamp(this.vehicle.time.seconds * 1000)
          : this.defaultValues.chara;
      } else {
        return "";
      }
    },
  },
  methods: {
    ...mapMutationsOfLiveMap([
      "SET_SELECTED_VEHICLE",
    ]),
    onClick() {
      this.shade = true;
      this.SET_SELECTED_VEHICLE(this.vehicle);
      setTimeout(() => {
        this.shade = false;
      }, 300);
    },
    turnOverPicture() {
      this.picture = this.vehicle.type === this.VEHICLE_TYPE.VEHICLE ? this.vehicleIconInversion : this.heavyEquipmentIconInversion;
    },
    setOriginalPicture() {
      this.picture = this.vehicle.type === this.VEHICLE_TYPE.VEHICLE ? this.vehicleIcon : this.heavyEquipmentIcon;
    },
  },
  mounted() {
    this.setOriginalPicture();
  },
};
</script>

<style lang="scss">
.clicked-card-opacity {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 0.2rem;
  background-color:white;
  opacity: 0.3;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
